import {animated} from 'react-spring';

import styled, {css} from 'styled-components';

import {
  InfoDropdown as BaseInfoDropdown,
  Td as BaseTd,
  Th as BaseTh,
  Tr as BaseTr,
  getTableCellWidth,
} from '@edna/components';
import {Icon, Stack} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {CollapsibleSection as BaseCollapsibleSection} from 'src/components';
import {EChannelType} from 'src/constants';

export const ScrollContainer = styled(Stack).attrs((props) => ({size: '4', ...props}))`
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
`;

export const Card = styled.div`
  width: 100%;
  ${mixins.stack({size: '2', direction: 'ROW'})};

  ${({theme}) => css`
    padding: ${theme.spacing.s4};
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br1};
  `};
`;

export const Pricing = styled.div`
  ${mixins.stack({size: '4'})};
  width: 100%;
  & * {
    white-space: break-spaces;
  }

  ${({theme}) => css`
    margin-top: ${theme.spacing.s4};
  `};
`;

const COLUMNS_WIDTH = {
  [EChannelType.VIBER]: ['34%', '33%', '33%'],
  [EChannelType.WHATSAPP]: ['27.5%', '14.5%', '14.5%', '14.5%', '14.5%'],
};

export const Td = styled(BaseTd)`
  padding: ${({theme}) => theme.spacing.s2} 0;
`;

export const Th = styled(BaseTh)`
  white-space: break-spaces;
  padding: ${({theme}) => theme.spacing.s1} 0;
`;

export const Tr = styled(BaseTr)<{noBorder?: boolean}>`
  width: 100%;
  padding: 0;

  ${({noBorder}) =>
    noBorder &&
    css`
      border: none;
    `};
`;

export const CollapsibleSection = styled(BaseCollapsibleSection)<{
  channelType: EChannelType.WHATSAPP | EChannelType.VIBER;
}>`
  width: 100%;
  margin-top: ${({theme}) => theme.spacing.s4};

  ${Th}, ${Td} {
    ${({channelType}) => getTableCellWidth(COLUMNS_WIDTH[channelType])}
  }

  ${Tr} {
    &:last-child:not(:first-child) {
      border: none;
    }
  }

  &:not(:last-child) {
    margin: 0;
    border: none;
  }
`;

export const LinkIcon = styled(Icon)`
  position: relative;
  bottom: 1px;
  margin-left: ${({theme}) => theme.spacing.s1};
`;

export const LoadingContainer = styled.div`
  ${mixins.stack({size: '4'})};
  width: 100%;
  margin-top: ${({theme}) => theme.spacing.s4};
`;

export const PricingInfo = styled.div`
  ${mixins.stack({size: '4'})};
  white-space: break-spaces;
  padding-top: ${({theme}) => theme.spacing.s3};
`;

export const Table = styled.table<{columns: number}>`
  width: 100%;

  ${Th}, ${Td} {
    ${({columns}) => getTableCellWidth(new Array(columns).fill(`calc(100% / ${columns})`))}
  }
`;

export const Animated = styled(animated.div)`
  width: 100%;
`;

export const InfoDropdown = styled(BaseInfoDropdown)`
  margin-left: 2px;
`;
